import { useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment-timezone'
import { formatTime } from '@calendly/booking-kit/services/time_format'

import { timezoneSelector } from 'selectors'
import { currentUserSelector } from 'selectors/user'
import { inviteeEventHasConflictSelector } from 'selectors/mutual_availability'
import { useI18n } from 'locales'

import { Wrapper, ConflictMarker, Name, Time } from './styles'

const formatTimeSpan = (startTime, endTime, timezone, timeNotation) => (
  `${formatTime(moment(startTime).tz(timezone), timeNotation)}
      - ${formatTime(moment(endTime).tz(timezone), timeNotation)}`
)

const InviteeEvent = ({
  id,
  startTime,
  endTime,
  eventName,
  containerScreenPosition,
  autoScroll,
  allDay
}) => {
  const { i18n } = useI18n()
  const ref = useRef()
  const timezone = useSelector(timezoneSelector)
  const currentUser = useSelector(currentUserSelector)
  const hasConflict = useSelector((state) => inviteeEventHasConflictSelector(state, { id }))
  const { top: containerTop, bottom: containerBottom } = containerScreenPosition

  useEffect(() => {
    if (!autoScroll) return
    const { top, bottom } = ref.current.getBoundingClientRect()
    if (top >= containerTop && bottom <= containerBottom) return

    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
  }, [autoScroll, containerTop, containerBottom])

  return (
    <Wrapper hasConflict={hasConflict} ref={ref} allDay={allDay}>
      <Time>
        {
          allDay
            ? i18n.t('publisher.mutual_availability.all_day', { locale: currentUser.locale })
            : formatTimeSpan(startTime, endTime, timezone, currentUser.time_notation)
        }
      </Time>
      <Name>{eventName}</Name>
      {hasConflict && <ConflictMarker>{i18n.t('publisher.mutual_availability.conflict', { locale: currentUser.locale })}</ConflictMarker>}
    </Wrapper>
  )
}

export default InviteeEvent
